import { useEffect, useState } from 'react';

type UserIconProps = {
  icon: string;
  size: 's' | 'm' | 'l';
  isOnline?: boolean;
}

export default function UserIcon({ icon, size, isOnline }: UserIconProps) {
  const [widthHeight, setWidthHeight] = useState<number>();
  const [localIcon, setLocalIcon] = useState<string>('https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png');

  useEffect(() => {
    switch (size) {
      case 's':
        setWidthHeight(24)
        break;
      case 'm':
        setWidthHeight(32)
        break;
      case 'l':
        setWidthHeight(44)
        break;
    }
  }, [])

  // useEffect(() => {
  //   api.get(icon).then((res) => {
  //     if (res.status === 200) {
  //       setLocalIcon(icon)
  //       return
  //     }
  //   }).catch(() => {
  //     setLocalIcon('https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png')
  //   })
  // }, [icon])

  return (
    <div style={{ borderRadius: 32, border: isOnline ? '2px solid #6E30E8' : 'none', display: 'flex', alignItems: 'center' }}>
      <img style={{ width: widthHeight, height: widthHeight, borderRadius: 32 }} src={localIcon} />
    </div>
  )
}